import { createContext, Dispatch, SetStateAction } from 'react';
import { IMessage, INlpResponse, ITopic, ITopicGroup, TNullable } from '@common/types';

interface IChatContext {
  topics: Array<ITopic>;
  topicGroups: Array<ITopicGroup>;
  selectedTopic: string;
  setSelectedTopic: Dispatch<SetStateAction<string>>;
  messages: Array<IMessage>;
  responses: Array<{ id: number; response: INlpResponse }>;
  addMessage: (message: IMessage) => void;
  addResponse: (id: number, response: INlpResponse) => void;
  agreedToDisclaimer: boolean;
  setAgreedToDisclaimer: (newValue: TNullable<boolean>) => void;
  agreedToDisclaimerPerSession: boolean;
  setAgreedToDisclaimerPerSession: (newValue: boolean) => void;
  showAgreementBanner: boolean;
  setShowAgreementBanner: Dispatch<SetStateAction<boolean>>;
}

const initialState: IChatContext = {
  topics: [],
  topicGroups: [],
  selectedTopic: '',
  setSelectedTopic: () => '',
  messages: [],
  addMessage: () => null,
  responses: [],
  addResponse: () => null,
  agreedToDisclaimer: false,
  setAgreedToDisclaimer: () => null,
  agreedToDisclaimerPerSession: false,
  setAgreedToDisclaimerPerSession: () => null,
  showAgreementBanner: false,
  setShowAgreementBanner: () => null,
};

export default createContext<IChatContext>(initialState);
